import React, { useEffect } from 'react';
import { trackFunnelStep } from '../analytics';
import { trackMetaInitiateCheckout } from '../metaPixel';
import {
  Box,
  Container,
  Typography,
  CircularProgress,
  Stack,
} from '@mui/material';

const CheckoutStart = ({ onInitiateCheckout }) => {
  // Effect intentionally runs only on mount — initiates checkout redirect once
  useEffect(() => {
    trackFunnelStep('checkout_start');
    trackMetaInitiateCheckout();
    onInitiateCheckout?.();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: '#f5f5f5',
      }}
    >
      <Container maxWidth="sm">
        <Stack spacing={4} alignItems="center">
          {/* Logo */}
          <Box component="img" src="/rp-barcode-text-1024x167.svg" alt="Reseller Pro" sx={{ height: { xs: 40, sm: 48 }, width: 'auto' }} />

          {/* Loading Indicator */}
          <CircularProgress size={60} thickness={4} />

          {/* Message */}
          <Stack spacing={2} alignItems="center">
            <Typography
              variant="h5"
              sx={{
                fontWeight: 600,
                color: '#1a1a1a',
                textAlign: 'center',
              }}
            >
              Preparing Your Free Trial
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: '#666',
                textAlign: 'center',
                maxWidth: 400,
              }}
            >
              We're redirecting you to our secure checkout page. This will only take a moment...
            </Typography>
          </Stack>

          {/* Trust Badge */}
          <Box
            sx={{
              mt: 4,
              p: 2,
              bgcolor: 'white',
              borderRadius: 2,
              boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            }}
          >
            <Typography
              variant="caption"
              sx={{
                color: '#999',
                textAlign: 'center',
                display: 'block',
              }}
            >
              🔒 Secured by Stripe
            </Typography>
          </Box>
        </Stack>
      </Container>
    </Box>
  );
};

export default CheckoutStart;
